import { z } from 'zod';
/**
 * The browser hands us a PushSubscription object; these are the only parts of
 * it the server needs in order to encrypt and deliver a message.
 */
export const pushSubscribeSchema = z.object({
    endpoint: z.string().url().max(2000),
    keys: z.object({
        p256dh: z.string().min(1).max(255),
        auth: z.string().min(1).max(255),
    }),
    userAgent: z.string().max(300).optional(),
});
export const pushUnsubscribeSchema = z.object({ endpoint: z.string().url().max(2000) });
//# sourceMappingURL=notification.contract.js.map